import { render, staticRenderFns } from "./theModalEnfermeria.vue?vue&type=template&id=e771ea34&scoped=true&"
import script from "./theModalEnfermeria.vue?vue&type=script&lang=js&"
export * from "./theModalEnfermeria.vue?vue&type=script&lang=js&"
import style0 from "./theModalEnfermeria.vue?vue&type=style&index=0&id=e771ea34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e771ea34",
  null
  
)

export default component.exports